export const SITE_URL = import.meta.env.VITE_SITE_URL || "https://usfanslink.cyou";

export const FAVICON_URL =
  "https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/2277e9ffbdee9fd651886f1aeeba0d56.jpeg";

const BRAND = "USFansLink";
const SITE_DESCRIPTION =
  "Independent USFans Spreadsheet resource hub with product lists, seller guides, shipping info, QC tips and safety guides.";

export function buildWebsiteSchema(): Record<string, unknown> {
  return {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: BRAND,
    url: SITE_URL,
    description: SITE_DESCRIPTION,
    inLanguage: "en",
  };
}

export function buildOrganizationSchema(): Record<string, unknown> {
  return {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: BRAND,
    url: SITE_URL,
    logo: FAVICON_URL,
  };
}

export interface ArticleSeoInput {
  title: string;
  description: string;
  path: string;
  image?: string;
  datePublished?: string;
  dateModified?: string;
}

export function buildArticleSchema(input: ArticleSeoInput): Record<string, unknown> {
  const schema: Record<string, unknown> = {
    "@context": "https://schema.org",
    "@type": "Article",
    headline: input.title,
    description: input.description,
    url: `${SITE_URL}${input.path}`,
    mainEntityOfPage: {
      "@type": "WebPage",
      "@id": `${SITE_URL}${input.path}`,
    },
    author: {
      "@type": "Organization",
      name: BRAND,
    },
    publisher: {
      "@type": "Organization",
      name: BRAND,
      logo: {
        "@type": "ImageObject",
        url: FAVICON_URL,
      },
    },
    inLanguage: "en",
  };

  if (input.image) {
    schema.image = input.image;
  }
  if (input.datePublished) {
    schema.datePublished = input.datePublished;
  }
  if (input.dateModified) {
    schema.dateModified = input.dateModified;
  }

  return schema;
}